// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"a64b2a36","162":"3de859d5","171":"9e0fb10a","400":"21cb9b8e","453":"7a599889"}[chunkId] + ".chunk.js";
};